// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./css/components/block-reassurance.scss
// module id = 59
// module chunks = 0